import { render, staticRenderFns } from "./TaskListEntry.vue?vue&type=template&id=7d996c2a&scoped=true&"
import script from "./TaskListEntry.vue?vue&type=script&lang=js&"
export * from "./TaskListEntry.vue?vue&type=script&lang=js&"
import style0 from "./TaskListEntry.vue?vue&type=style&index=0&id=7d996c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d996c2a",
  null
  
)

export default component.exports